import React, { useEffect, useState } from "react";
import { Button, Modal, Table, Row, Col } from "react-bootstrap";
import ToolkitProvider, {
    Search,
    CSVExport,
} from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import axios from "axios";
import { MdDeleteOutline } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
const BookingManger = () => {
    const [selectedBooking, setSelectedBooking] = useState(null);

    const handleAssignJob = async (vendorId, vendor) => {
        if (!selectedBooking) {
          alert("No booking selected!");
          return;
        }
      
        const payload = { vendorId, vendor };
      
        try {
          console.log("Sending request to assign vendor:", {
            bookingId: selectedBooking?._id,
            payload,
          });
      
          const response = await axios.put(
            `https://vrpmpro.com/api/user/bookings/${selectedBooking?._id}/assign-vendor`,
            payload,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer YOUR_AUTH_TOKEN`,
              },
            }
          );
      
          console.log("Response from server:", response.data);
          alert("Booking assigned successfully!");
          getVehicle()
          setVendorModalVisible(false);
      
          // Optionally, refresh bookings or vendor data here.
        } catch (error) {
          console.error("Error assigning booking:", error.response || error);
          const errorMessage =
            error.response?.data?.message || "Failed to assign booking. Please try again.";
          alert(errorMessage);
        }
      };
      
      
    const [vendorModalVisible, setVendorModalVisible] = useState(false);

    const handleVendorView = () => {
        setVendorModalVisible(true);
    };
    
    const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  // Fetch vendor data from API
  useEffect(() => {
    const fetchVendors = async () => {
      try {
        const response = await axios.get('https://vrpmpro.com/api/vendor/getallvendors');
        const sortedVendors = response.data.vendors.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setVendors(sortedVendors);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch vendor data');
        setLoading(false);
        console.error('Error fetching vendor data:', err);
        alert('Error fetching vendor data'); // Displaying error using alert
      }
    };

    fetchVendors();
  }, []); // Empty dependency array to call the API once when the component mounts


    const [show, setShow] = useState(false);
    const [editid, seteditid] = useState("");
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [vehicleTypes, setVehicleTypes] = useState([]);
console.log("vehicletypes,",vehicleTypes);
    const getVehicle = async () => {
        try {
            let res = await axios.get("https://vrpmpro.com/api/user/bookings");
            if (res.status == 200) {
                setVehicleTypes(res.data.success || [])
            }
        } catch (error) {
            console.log(error);
            setVehicleTypes([]);
        }
    }

    useEffect(() => {
        let isMounted = true;
        
        const getVehicle = async () => {
            try {
                let res = await axios.get("https://vrpmpro.com/api/user/bookings");
                if (res.status == 200 && isMounted) {
                    setVehicleTypes(res.data.success || [])
                }
            } catch (error) {
                console.log(error);
                if (isMounted) {
                    setVehicleTypes([]);
                }
            }
        };
        
        getVehicle();
        
        return () => {
            isMounted = false;
        };
    }, []);

    const customTotal = (from, to, size) => (
        <span className="react-bootstrap-table-pagination-total">
            Showing {from} to {to} of {size} Results
        </span>
    );

    // console.log("vehicleTypes",vehicleTypes);

    const { SearchBar, ClearSearchButton } = Search;
    const { ExportCSVButton } = CSVExport;
    const options = {
        paginationSize: 4,
        pageStartIndex: 0,
        firstPageText: "First",
        prePageText: "Back",
        nextPageText: "Next",
        lastPageText: "Last",
        nextPageTitle: "First page",
        prePageTitle: "Pre page",
        firstPageTitle: "Next page",
        lastPageTitle: "Last page",
        showTotal: true,
        paginationTotalRenderer: customTotal,
        disablePageTitle: true,
        sizePerPageList: [
            {
                text: "5",
                value: 5,
            },
            {
                text: "10",
                value: 10,
            },
            {
                text: "All",
                value: vehicleTypes?.length || 0,
            },
        ], // A numeric array is also available. the purpose of above example is custom the text
    };
    const [typeName, setTypeName] = useState("");
    const [description, setDescription] = useState("");
    const [typeImage, setTypeImage] = useState(null);
    const [price, setPrice] = useState("");
    const [gst, setGst] = useState("");
    const [editShow, seteditshow] = useState(false);

    const columns = [
        {
            text: "S.No",
            sort: true,
            formatter: (cell, row, rowIndex) => {
                return (
                    <div>
                        {rowIndex + 1}
                    </div>
                )
            }
        },
        {
            dataField: "customerName",
            text: "Name",
            // formatter: (cell, row, rowIndex) => {
            //     return (
            //         <div>
            //             {row?.typeImage && <img src={`https://vrpmpro.com/vehicletypes/${row?.typeImage}`} style={{ width: "100px", height: "auto", borderRadius: "10px" }} />}
            //         </div>
            //     )
            // }

        },
        {
            dataField: "Number",
            text: "phone",
            formatter: (cell, row, rowIndex) => {
                return (
                    <div>
                       {row?.phone}
                    </div>
                )
            }

        },
        {
            dataField:"setviceType",
            text:"Service Type"
        },
        {
            dataField: "pickupAddress",
            text: "Pickup Address",

        },
        {
            dataField: "deliveryAddress",
            text: "Drop Address",

        },
     
        {
            dataField: "Cart",
            text: "Item",
            formatter: (cell, row) => {
              console.log("Row Data:", row); 
              return row.Cart?.length > 0
                ? row.Cart.map((item) => item.itemName).join(", ") 
                : "No Items"; 
            }
          }
          
,          
        {
            dataField: "bookingDate",
            text: "Date",

        },
        {
            dataField: "bookingTime",
            text: "Time",
        },

        {
            dataField: "totalPrice",
            text: " Price",
            sort: true,
        },
        {
            dataField: "status",
            text: "Vendor Status",
            formatter: (cell, row) => {
              return (
                <div>
                  <p><strong>Booking Id:</strong> {row._id || "N/A"}</p>
                  <p><strong>Vendor Id:</strong> {row?.assignedVendor?.vendorId|| "N/A"}</p>
                  <p><strong>Vendor Name:</strong> {row.assignedVendor?.vendorName || "N/A"}</p>
                  <p><strong>Vehicle Name:</strong> {row.vehicleType || "N/A"}</p>
                  <p><strong>Booking Status:</strong> {row.status || "N/A"}</p>
                </div>
              );
            },
          },
        // {
        //     dataField: "bookingStatus",
        //     text: "Booking Status",
        //     formatter: (cell, row) => {
        //       return (
        //         <div>
        //           <p><strong>Status:</strong> {row.bookingStatus || "N/A"}</p>
        //           <p><strong>Remarks:</strong> {row.bookingStatus || "N/A"}</p>
        //         </div>
        //       );
        //     },
        //   },
        {
            dataField: "assign",
            text: "Assign Vendor",
            formatter: (cell, row) => (
                <button 
                    className="btn btn-success btn-sm" 
                    onClick={() => {
                        setSelectedBooking(row);
                        setVendorModalVisible(true);
                    }}
                >
                    Assign Vendor
                </button>
            ),
        }
        
        
    
        // {
        //     dataField: "gst",
        //     text: "Action",
        //     formatter: (cee, row) => {
        //         return <div className="d-flex gap-2">

        //             <abbr title="Edit" className="btn btn-outline-primary" style={{ cursor: "pointer" }} onClick={() => {
        //                 setTypeName(row?.typeName)
        //                 setDescription(row?.description);
        //                 setPrice(row?.price);
        //                 setGst(row?.gst)
        //                 seteditid(row?._id);
        //                 seteditshow(true);
        //             }} >
        //                 <FaEdit size={25} />
        //             </abbr>
        //             <abbr title="Delete" className="btn btn-outline-danger" style={{ cursor: "pointer" }}>
        //                 <MdDeleteOutline size={25} />
        //             </abbr>

        //         </div>
        //     }

        // },

    ]
    const defaultSorted = [{
        dataField: 'propertytype',
        order: 'desc'
    }];



    const handleImageChange = (e) => {
        setTypeImage(e.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let check = vehicleTypes.filter((ele) => ele?.typeName == typeName && ele?.description == description);
        if (check.length != 0) return alert("Type of Vehicle already exits");

        // Prepare form data
        const formData = new FormData();
        formData.append("typeName", typeName);
        formData.append("description", description);
        formData.append("typeImage", typeImage);
        formData.append("price", price);
        formData.append("gst", gst);

        try {
            // Make API call to backend
            const response = await axios.post(
                "https://vrpmpro.com/api/admin/vehicle-types", 
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data", // Important to handle file uploads
                    },
                }
            );
            // Handle response from the API
            console.log(response.data);
            alert("Vehicle type added successfully!");
            handleClose()
            setTypeName('')
            setDescription('');
            setPrice('');
            setGst('');
            setTypeImage("")
            getVehicle()
        } catch (error) {
            // Handle errors
            console.error("Error submitting form", error);
            alert("Error submitting form. Please try again.");
        }
    };

    const handleEdit = async (e) => {
        e.preventDefault();

        let check = vehicleTypes.filter((ele) => ele?.typeName == typeName && ele?.description == description && ele?._id != editid);
        if (check.length != 0) return alert("Type of Vehicle already exits");

        // Prepare form data
        const formData = new FormData();
        formData.append("typeName", typeName);
        formData.append("description", description);
        formData.append("typeImage", typeImage);
        formData.append("price", price);
        formData.append("gst", gst);

        try {
            // Make API call to backend
            const response = await axios.put(
                "https://vrpmpro.com/api/admin/vehicle-types/" + editid, // Replace with your actual API endpoint
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data", // Important to handle file uploads
                    },
                }
            );
            // Handle response from the API
            console.log(response.data);
            alert("Vehicle type updated successfully!");
            seteditshow(false)
            setTypeName('')
            setDescription('');
            setPrice('');
            setGst('');
            setTypeImage("")
            getVehicle()
        } catch (error) {
            // Handle errors
            console.error("Error submitting form", error);
            alert("Error submitting form. Please try again.");
        }
    };

    return (
        <div className="ml-4">
            <h1 className="pt-4 pb-3" style={{ color: "white" }}>Booking Packer & Mover</h1>
            <div className="container">
                <div className="card card-body">
                    <ToolkitProvider
                        keyField="id"
                        data={vehicleTypes}
                        columns={columns}
                        defaultSorted={defaultSorted}
                        search
                        exportCSV={{
                            fileName: "properties.csv",
                            blobType: "text/csv;charset=ansi",
                        }}
                    >
                        {(props) => (
                            <div>
                                <span className="pr-5 mr-auto">
                                    <ExportCSVButton
                                        className="btn-outline-success"
                                        {...props.csvProps}
                                    >
                                        Export to CSV
                                    </ExportCSVButton>
                                </span>
                                {"     "}
                                <span className="ps-5 ml-5 mt-3">
                                    <SearchBar
                                        className="form-control "
                                        {...props.searchProps}
                                    />
                                </span>
                                {"      "}
                                <ClearSearchButton
                                    className="btn-outline-info ms-5 "
                                    {...props.searchProps}
                                />
                                {/* <span className="ps-5 ml-5 mt-3">
                                    <button className='btn btn-outline-danger' onClick={handleShow}>Add Vehicle Type</button>
                                </span> */}

                                <hr />
                                <div className="table-responsive">
                                    <BootstrapTable
                                        keyField="patient"
                                        responsive
                                        hover
                                        columns={columns}
                                        data={vehicleTypes}
                                        pagination={paginationFactory(options)}
                                        {...props.baseProps}
                                    />
                                </div>
                            </div>
                        )}
                    </ToolkitProvider>
                </div>
            </div>
{/* //  vendor list  */}
<Modal show={vendorModalVisible} onHide={() => setVendorModalVisible(false)} size="md" centered>
    <Modal.Header closeButton>
        <Modal.Title>Vendor List</Modal.Title>
    </Modal.Header>
    <Modal.Body>
        <div className="list-group" style={{ maxHeight: "500px", overflowY: "auto" }}>
            {vendors.map((vendor, index) => (
                <div className="list-group-item d-flex justify-content-between align-items-center" key={vendor.id}>
                    <div>
                        <h5 className="mb-1">Vendor {index + 1}</h5>
                        <p className="mb-1"><strong>Vendor Id:</strong> {vendor?._id}</p>
                        <p className="mb-1"><strong>Vendor Name:</strong> {vendor?.vendorName}</p>
                        <p className="mb-1"><strong>Contact:</strong> {vendor?.VendorcontactNumber}</p>
                        <p className="mb-0"><strong>Email:</strong> {vendor?.vendorEmail}</p> 
                        <p className="mb-0"><strong>Vehicle Type:</strong> {vendor?.vehicleName}</p>
                        <p className="mb-0"><strong>Vehicle Number:</strong> {vendor?.vehicleNumber}</p>
                    </div>
                    {selectedBooking?.assignedVendor?.vendorId==vendor?._id ? (  <button 
                        className="btn btn-success btn-sm" 
                      >
                        Assigned
                    </button>):(              <button 
                        className="btn btn-primary btn-sm" 
                        onClick={() => handleAssignJob(vendor._id,{
                            vendorId: vendor?._id,
                            vendorName: vendor?.vendorName,
                            vendorEmail: vendor?.vendorEmail,
                            vendorContact: vendor?.VendorcontactNumber,
                            vehicleNumber:vendor?.vehicleNumber
                        })}
                    >
                        Assign Job
                    </button>)}
                  
                </div>
            ))}
        </div>
    </Modal.Body>
</Modal>



            {/* Modal */}
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Vehicle Type</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div class="container mt-2">
                        <form onSubmit={handleSubmit}>

                            <div class="mb-3">
                                <label for="typeName" class="form-label">Vehicle Type</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    id="typeName"
                                    value={typeName}
                                    placeholder="Enter type name (e.g., Mini Truck, Tempo)"
                                    required
                                    onChange={(e) => setTypeName(e.target.value)}
                                />
                            </div>


                            <div class="mb-3">
                                <label for="description" class="form-label">Description</label>
                                <input type="text"
                                    class="form-control"
                                    id="description"
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    placeholder="Ex- 3 Wheeler (5.5 ft)"
                                />
                            </div>


                            <div class="mb-3">
                                <label for="typeImage" class="form-label">Vehicle Image</label>
                                <input
                                    type="file"
                                    class="form-control"
                                    id="typeImage"
                                    required
                                    accept="image/*"
                                    onChange={handleImageChange}
                                />
                            </div>

                            <div class="mb-3">
                                <label for="price" class="form-label">Price</label>
                                <input
                                    type="number"
                                    class="form-control"
                                    id="price"
                                    placeholder="Enter price"
                                    min="0"
                                    value={price}
                                    onChange={(e) => setPrice(e.target.value)}
                                />
                            </div>


                            <div class="mb-3">
                                <label for="gst" class="form-label">GST</label>
                                <input
                                    type="number"
                                    class="form-control"
                                    id="gst"
                                    placeholder="Enter GST ex:- 80"
                                    min="0"
                                    value={gst}
                                    onChange={(e) => setGst(e.target.value)}
                                />
                            </div>

                            <button type="submit" class="btn btn-outline-success">Submit</button>
                        </form>
                    </div>


                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-outline-danger" onClick={handleClose}>
                        Close
                    </button>
                    {/* <button className="btn btn-outline-success" onClick={handleClose}>
                        Save Changes
                    </button> */}
                </Modal.Footer>
            </Modal>

            {/* Modal */}
            <Modal show={editShow} onHide={() => seteditshow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Vehicle Type</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div class="container mt-2">
                        <form onSubmit={handleEdit}>

                            <div class="mb-3">
                                <label for="typeName1" class="form-label">Vehicle Type</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    id="typeName1"
                                    value={typeName}
                                    placeholder="Enter type name (e.g., Mini Truck, Tempo)"
                                    required
                                    onChange={(e) => setTypeName(e.target.value)}
                                />
                            </div>


                            <div class="mb-3">
                                <label for="description1" class="form-label">Description</label>
                                <input type="text"
                                    class="form-control"
                                    id="description1"
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    placeholder="Ex- 3 Wheeler (5.5 ft)"
                                />
                            </div>


                            <div class="mb-3">
                                <label for="typeImage1" class="form-label">Vehicle Image</label>
                                <input
                                    type="file"
                                    class="form-control"
                                    id="typeImage1"

                                    accept="image/*"
                                    onChange={handleImageChange}
                                />
                            </div>

                            <div class="mb-3">
                                <label for="price1" class="form-label">Price</label>
                                <input
                                    type="number"
                                    class="form-control"
                                    id="price1"
                                    placeholder="Enter price"
                                    min="0"
                                    value={price}
                                    onChange={(e) => setPrice(e.target.value)}
                                />
                            </div>


                            <div class="mb-3">
                                <label for="gst1" class="form-label">GST</label>
                                <input
                                    type="number"
                                    class="form-control"
                                    id="gst1"
                                    placeholder="Enter GST ex:- 80"
                                    min="0"
                                    value={gst}
                                    onChange={(e) => setGst(e.target.value)}
                                />
                            </div>

                            <button type="submit" class="btn btn-outline-success">Save Changes</button>
                        </form>
                    </div>


                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-outline-danger" onClick={() => seteditshow(false)}>
                        Close
                    </button>
                    {/* <button className="btn btn-outline-success" onClick={handleClose}>
                        Save Changes
                    </button> */}
                </Modal.Footer>
            </Modal>
        </div>

    );
};

export default BookingManger;
